import "./svg/checkmark-bold.svg"

export default {
    name: "checkmark-bold",
    viewBox: "24 24",
}
